import { radius, tok, tokPx } from '@sunwebgroup/ui-components'
import { Sheet, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const SheetContentTitle = styled(Typography)`
  margin-bottom: ${tokPx('primitives_space_16')};
`

const FieldSection = styled.div`
  background-color: ${tok('semantics_views_tinted_background_color')};
  padding: ${tokPx('primitives_space_12')};
  margin-bottom: ${tokPx('primitives_space_8')};
  border-radius: ${radius('primitives_corner_radius_m')};
`

const FieldSectionTitle = styled(Typography)`
  color: ${tok('semantics_content_secondary_color')};
`

const SheetContentStyled = styled(Sheet.Content)`
  color: ${tok('semantics_content_color')};
`

const SheetHeaderStyled = styled(Sheet.Header)`
  color: ${tok('semantics_content_color')};
`

export { FieldSection, FieldSectionTitle, SheetContentStyled, SheetContentTitle, SheetHeaderStyled }
